// extracted by mini-css-extract-plugin
module.exports = {"container":"e_2d","link":"e_3d","lastLink":"e_4d","arrow":"e_5d"};